"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isElementsUnique = exports.put = exports.remove = void 0;
var lodash_1 = require("lodash");
/**
 * 配列から idx 番目の要素を取り除く。idxが負なら何もしない。
 * @param items
 * @param idx
 */
var remove = function (items, idx) {
    if (idx < 0) {
        return items;
    }
    return items.slice(0, idx).concat(items.slice(idx + 1));
};
exports.remove = remove;
/**
 * 配列から idx 番目に要素を追加する。idxが負なら何もしない。
 * @param items
 * @param idx
 */
var put = function (items, idx, item) {
    if (idx < 0) {
        return items;
    }
    else if (items.length < idx) {
        return items.concat(new Array(idx - items.length)).concat(item);
    }
    else {
        return items
            .slice(0, idx)
            .concat(item)
            .concat(items.slice(idx + 1));
    }
};
exports.put = put;
/**
 * 配列に含まれる要素がすべて同じか（ lodash の isEqual で true か）をチェックする。
 * 空配列の場合は true になる。
 *
 * @param items
 */
var isElementsUnique = function (items) {
    if (items.length <= 1) {
        return true;
    }
    return items.slice(1).every(function (item) { return (0, lodash_1.isEqual)(item, items[0]); });
};
exports.isElementsUnique = isElementsUnique;
